import React from 'react';
import { PageHeader } from '../../../../shared/components/patterns';

const ProposalsHeader = () => {
  return (
    <PageHeader
      title="Proposte affari"
      description="Pipeline commerciale per nuove opportunità di cessione crediti"
    />
  );
};

export default ProposalsHeader;
